export const CHAT_BOT_SHOW_AFTER_SPINNER = 'CHAT_BOT_SHOW_AFTER_SPINNER';

export const chatBotShowAfterSpinner = (data) => ({
  type: CHAT_BOT_SHOW_AFTER_SPINNER,
  payload: data,
});
